import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-footer p-2" }

import i18n from "@/lang/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonArea',
  props: {
    downloading: { type: Boolean },
    isShowableDownloadButton: { type: Boolean }
  },
  emits: ['download'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: props.downloading ? null : 'Every24hoursReport' },
      class: _normalizeClass({ 'disabled-link': props.downloading })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          class: "m-1 reset-btn",
          disabled: props.downloading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.every24HoursReport.preview.returnPage')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["to", "class"]),
    (__props.isShowableDownloadButton)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "m-1 exec-btn",
          loading: props.downloading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('download')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.downloadBtn')), 1)
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})